import React from 'react';
import TruncateText from '../../TruncateText';
import Paragraph from '../../Paragraph';

export interface InlinePageTextAreaProps {
    paragraph: string;
}
export default function InlinePageTextArea({ paragraph }: InlinePageTextAreaProps) {
    return (
        <div>
            <Paragraph>
                <TruncateText text={paragraph} maxHeight={80}></TruncateText>
            </Paragraph>
        </div>
    );
}

InlinePageTextArea.calculateMaxHeightPercentage = function (): number {
    return 0.25;
};
